export const orderedList = {
	group: "block list",
	content: "listItem+",
	attrs: {
		start: { default: 1 },
		tight: { default: false },
	},
};
